query allSportsSelectionDisplayConfigurations {
  allSelectionDisplayConfigurations {
    nodes {
      sportId
      active
      selectionCode
      shortNamePattern
      longNamePattern
      position
      parameters
    }
  }
}
